import Axios from "axios";
// import NProgress from "nprogress";
// import "nprogress/nprogress.css";
// import {
// 	RSAEncrypt,
// 	sendEncryCode
// } from "../utils/jiaqian.js"
let service = Axios.create({
	// baseURL: "http://116.62.240.194:8000",
	// baseURL: "http://127.0.0.1:7001",
	baseURL: "https://hcrl.huicairen.net",
	// baseURL: '/api',
	timeout: 20000,
});
service.interceptors.request.use(
	config => {
		//NProgress.start();
		// JWT鉴权：
		// let newkey = Object.keys(config.data).sort();
		// let newObj = {};
		// for (let i = 0; i < newkey.length; i++) {
		// 	newObj[newkey[i]] = config.data[newkey[i]];
		// }
		// config.data=newObj
		// let sign = RSAEncrypt(config.data);
		// sign ? config.data["sign"] = sign : ""
		// SESSION鉴权：
		// let cookieToken: string | null = sessionStorage.getItem("cookieToken");
		// if (cookieToken) {
		//   // PHPSESSID :cookie名是不确定  如果是php大概率是PHPSESSID；其他其他语言100%不是这个 PHPSESSID 具体是什么问后端程序
		//   config.headers["Cookie"] = `PHPSESSID=${cookieToken}`;
		// }

		if (!config.data) {
			config.data = {};
		}

		// if (sessionStorage.getItem("login")) {
		// 	// 因为每个需要验证用户登录状态的接口 都需要一个token的数据 实现了统一处理  而不是每个接口都单独写一次
		// 	config.data.token = sessionStorage.getItem("login");
		// }

		return config;
	},
	err => {
		//NProgress.done();
		console.log(err);
		Promise.reject(err);
	}
);
service.interceptors.response.use(
	response => {
		// if (response.data.code == 401) {
		// 	sessionStorage.removeItem("token")
		// 	location.href = "/"
		// }
		// let aa = typeof (response.data.data)
		// if (aa === 'string') {
		// 	let data = sendEncryCode(response.data.data)
		// 	console.log(data, 111111111111);
		// 	response.data["data"] = JSON.parse(data)
		// }
		//NProgress.done();
		return response;
	},
	err => {
		//NProgress.done();
		// console.log(err.response);
		if (err.response) {
			// console.log(err.response.status); //
			if (err.response.status == 400) {
				// 未登录
				location.href = "/login"
			}
			if (err.response.status == 500) {
				// 未登录
				return { data: { code: 500 } }
			}
		}
		return err;
	}
);

export default { service };
